import ReactGA from 'react-ga4';

const gaItemEventLabel = (item, isSidebar, isTopper) => {
  let label = '';
  const isDumpertTv =
    item.tags
      .toString()
      .split(' ')
      .findIndex((tag) => tag.startsWith('dumperttv')) !== -1;

  if (!item.nopreroll && !item.nsfw) {
    if (isSidebar && isTopper) {
      label = 'top5';
    } else if (!isTopper && isDumpertTv) {
      label = 'dumperttv';
    } else {
      label = 'default';
    }
  } else {
    if (item.nopreroll && item.nsfw) {
      label = 'nsfa_nsfw';
    } else if (item.nopreroll && !item.nsfw) {
      label = 'nsfa';
    } else if (!item.nopreroll && item.nsfw) {
      label = 'nsfw';
    }
  }
  return label;
};

const gaEvent = (action, label, category) => {
  const eventParams = {
    action: action.toLowerCase(),
    label: label.toLowerCase(),
    category: category ? category.toLowerCase() : action.toLowerCase(),
  };
  ReactGA.event(eventParams);
};

export { gaEvent, gaItemEventLabel };
